(() => {
    const root = document.querySelector('[data-cvt]')
    if (!root) return
    const $ = selector => root.querySelector(selector)
    const appUrl = root.dataset.appUrl.replace(/\/$/, '')
    const convexUrl = root.dataset.convexUrl
    const turnstileKey = root.dataset.turnstileKey
    const STEPS = ['read', 'products', 'design', 'review']

    const track = (event, properties = {}) => {
      try {
        window.posthog?.capture(event, properties)
      } catch {}
    }

    const form = $('[data-cvt-form]')
    const input = form.querySelector('[name="url"]')
    const submit = $('[data-cvt-submit]')
    const submitLabel = $('[data-cvt-submit-label]')
    const idleSubmitLabel = submitLabel.textContent
    const inline = root.hasAttribute('data-cvt-inline')
    const headerCta = document.querySelector('.cv-header__cta[data-cta="header"]')
    const headerCtaLabel = headerCta?.textContent
    const setResultState = done => {
      root.classList.toggle('cvt--done', done)
      if (headerCta) headerCta.textContent = done ? 'Install Cartivate' : headerCtaLabel
    }
    const errorBox = $('[data-cvt-error]')
    const frame = $('[data-cvt-frame]')
    const storeImg = $('[data-cvt-store-img]')
    storeImg.addEventListener('load', () => storeImg.classList.add('is-loaded'))
    let runId = null
    let unsubscribe = null
    let client = null
    let turnstileToken = ''
    let turnstileWidget = null
    let resultShown = false

    const show = view =>
      root.querySelectorAll('[data-cvt-view]').forEach(el => {
        el.hidden = el.dataset.cvtView !== view && !(inline && el.dataset.cvtView === 'form')
      })

    const signal = (type, detail = {}) => root.dispatchEvent(new CustomEvent(`cartivate:preview-${type}`, { detail }))

    // A backend result is not yet a presented cart: the reveal controller also
    // waits for the iframe. Keep the completed headline behind that same gate.
    const headline = $('[data-cvt-headline]')
    let backendReady = false
    let presentationComplete = false
    let currentBrandName = ''
    const renderHeadline = () => {
      const complete = backendReady && presentationComplete
      headline.classList.toggle('cvt-h2--complete', complete)
      if (!complete) {
        headline.textContent = backendReady ? `Your cart for ${currentBrandName}` : 'Designing your cart…'
        return
      }
      const firstLine = document.createElement('span')
      const secondLine = document.createElement('em')
      firstLine.textContent = 'A cart like no other.'
      secondLine.textContent = 'Cart 2.0 unlocked.'
      headline.replaceChildren(firstLine, document.createElement('br'), secondLine)
    }
    const resetHeadline = () => {
      backendReady = presentationComplete = false
      currentBrandName = ''
      renderHeadline()
    }
    root.addEventListener('cartivate:preview-start', resetHeadline)
    root.addEventListener('cartivate:preview-reset', resetHeadline)
    root.addEventListener('cartivate:preview-error', event => {
      if (!event.detail?.preserveSession) resetHeadline()
    })
    root.addEventListener('cartivate:preview-presented', () => {
      if (!backendReady || root.dataset.previewPhase !== 'ready') return
      presentationComplete = true
      renderHeadline()
    })

    const fail = message => {
      signal('error', { preserveSession: Boolean(runId && !$('[data-cvt-view="run"]').hidden) })
      errorBox.textContent = message
      errorBox.hidden = false
      submit.disabled = false
      submitLabel.textContent = idleSubmitLabel
      turnstileToken = ''
      if (turnstileWidget !== null) window.turnstile?.reset(turnstileWidget)
    }

    if (turnstileKey) {
      const mount = () =>
        (turnstileWidget = window.turnstile.render($('[data-cvt-turnstile]'), {
          sitekey: turnstileKey,
          callback: token => {
            turnstileToken = token
            submitPreset()
          },
          'expired-callback': () => (turnstileToken = ''),
        }))
      const wait = () => (window.turnstile ? mount() : setTimeout(wait, 100))
      wait()
    }

    // A store sent from the homepage's window (?url=) starts at once, as
    // soon as Turnstile has a token when it is on.
    let autoStart = false
    const submitPreset = () => {
      if (!autoStart || (turnstileKey && !turnstileToken)) return
      autoStart = false
      form.requestSubmit()
    }

    const convex = () => {
      if (!client) client = new window.convex.ConvexClient(convexUrl)
      return client
    }

    // Each step's state comes worked out with the run (progressOf in the
    // app, where every moment of a run is tested): the page only draws it.
    // Before the first update nothing is recorded, so reading is underway.
    const setStep = run => {
      STEPS.forEach((kind, i) => {
        root.querySelector(`[data-step="${kind}"]`).dataset.state =
          run.progress?.[kind] ?? (i === 0 ? 'active' : 'pending')
      })
    }

    // The latest few changes, newest first. Changes that land together
    // (one save can touch several parts) tick in one at a time.
    const SHOWN_CHANGES = 4
    const CHANGE_GAP_MS = 700
    let seenChanges = new Set()
    let pendingChanges = []
    let shownChanges = []
    let drip = null
    const showNextChange = () => {
      shownChanges.push(pendingChanges.shift())
      $('[data-cvt-changes]').replaceChildren(
        ...shownChanges.slice(-SHOWN_CHANGES).reverse().map((text, i) => {
          const li = document.createElement('li')
          li.textContent = text
          if (i === 0) li.classList.add('cvt-changes__new')
          return li
        })
      )
      if (!pendingChanges.length) {
        clearInterval(drip)
        drip = null
      }
    }
    const renderChanges = changes => {
      for (const change of changes) {
        const key = `${change.at}:${change.text}`
        if (seenChanges.has(key)) continue
        seenChanges.add(key)
        pendingChanges.push(change.text)
      }
      if (drip || !pendingChanges.length) return
      drip = setInterval(showNextChange, CHANGE_GAP_MS)
      showNextChange()
    }
    const resetChanges = () => {
      clearInterval(drip)
      drip = null
      seenChanges = new Set()
      pendingChanges = []
      shownChanges = []
      $('[data-cvt-changes]').replaceChildren()
    }

    // How long it has been working, against how long a run usually takes.
    let clock = null
    const startClock = createdAt => {
      clearInterval(clock)
      const tick = () => {
        const seconds = Math.max(0, Math.round((Date.now() - createdAt) / 1000))
        const time = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`
        $('[data-cvt-elapsed]').textContent = `${time} · usually a minute or two`
      }
      tick()
      clock = setInterval(tick, 1000)
    }

    const render = run => {
      if (!run) {
        show('form')
        fail('We could not find that cart any more. Try your store again.')
        return
      }
      if (['failed', 'error', 'cancelled', 'canceled'].includes(run.status)) {
        unsubscribe?.()
        unsubscribe = null
        show('form')
        return fail('Your cart could not finish. Please try your store again.')
      }
      const done = run.status === 'done'
      $('[data-cvt-device-url]').textContent = run.domain
      backendReady = done
      currentBrandName = run.brandName || run.domain || 'your store'
      if (!done) presentationComplete = false
      renderHeadline()
      setStep(run)
      const lines = run.narration || []
      $('[data-cvt-narration]').textContent = lines.length ? `“${lines[lines.length - 1].text}”` : ''

      // The store itself, behind the drawer, as a shopper sees it open: on a
      // laptop its whole homepage (the half-scale one the agent reads), or
      // its first screen when the whole page could not be drawn; its phone
      // one in the phone. The mobile source goes first, so a phone never
      // fetches the laptop picture.
      const mobileSource = $('[data-cvt-store-mobile]')
      if (run.screenshotMobileUrl && mobileSource.getAttribute('srcset') !== run.screenshotMobileUrl) {
        mobileSource.srcset = run.screenshotMobileUrl
      }
      const storeShot = run.screenshotPageUrl || run.screenshotUrl
      if (storeShot && storeImg.getAttribute('src') !== storeShot) storeImg.src = storeShot
      root.classList.toggle('cvt--no-shot', !storeShot)
      $('[data-cvt-placeholder]').hidden = Boolean(storeShot || run.settings)

      if (run.settings && frame.hidden) {
        frame.src = `${appUrl}/demo/frame/${encodeURIComponent(run.runId)}`
        frame.hidden = false
      }

      $('[data-cvt-result]').hidden = !done
      renderChanges(run.changes || [])
      $('[data-cvt-live]').hidden = done || !run.settings
      $('[data-cvt-elapsed]').hidden = done
      if (done) clearInterval(clock)
      else if (!clock) startClock(run.createdAt)
      $('[data-cvt-done]').hidden = !done
      $('[data-cvt-cta]').hidden = !done
      setResultState(done)
      if (done) {
        submit.disabled = false
        submitLabel.textContent = idleSubmitLabel
        $('[data-cvt-summary]').textContent = run.summary || 'Built from your brand and your products. Change quantities, add the upsell, and watch the reward bar fill.'
        const last = run.steps?.[run.steps.length - 1]
        const seconds = last ? Math.max(1, Math.round((last.at - run.createdAt) / 1000)) : 0
        const took = seconds >= 60 ? `${Math.floor(seconds / 60)}m ${seconds % 60}s` : `${seconds}s`
        $('[data-cvt-done]').textContent = seconds ? `Designed for you in ${took}` : 'Designed for you'
        if (!resultShown) {
          resultShown = true
          track('demo_result_shown', { run_id: run.runId, domain: run.domain })
        }
      }
      storeImg.alt = `Website preview for ${run.domain || 'your store'}`
      signal(done ? 'ready' : 'progress', {
        runId: run.runId,
        status: run.status,
        progress: run.progress || {},
        narration: run.narration || [],
        changes: run.changes || [],
        hasScreenshot: Boolean(storeShot || run.screenshotMobileUrl),
        hasSettings: Boolean(run.settings),
        domain: run.domain || '',
        brandName: run.brandName || '',
      })
    }

    const follow = id => {
      runId = id
      const url = new URL(location.href)
      url.searchParams.set('run', id)
      url.searchParams.delete('url')
      if (inline) url.hash = 'preview-experience'
      history.replaceState(null, '', url)
      $('[data-cvt-share-fallback]').value = url.href
      show('run')
      signal('start', { runId: id })
      setStep({})
      unsubscribe?.()
      unsubscribe = convex().onUpdate('demo/runs:get', { runId: id }, render, () =>
        { $('[data-cvt-narration]').textContent = 'Reconnecting…'; signal('connection-lost') }
      )
    }

    form.addEventListener('submit', async event => {
      event.preventDefault()
      errorBox.hidden = true
      let url
      try {
        const raw = input.value.trim()
        if (!raw || /\s/.test(raw)) throw new Error('address')
        const parsed = new URL(raw.includes('://') ? raw : `https://${raw}`)
        if (!['https:', 'http:'].includes(parsed.protocol) || parsed.username || parsed.password || parsed.port || !parsed.hostname.includes('.') || !/[a-z]{2,}$/i.test(parsed.hostname)) throw new Error('address')
        url = parsed.origin
      } catch {
        input.setAttribute('aria-invalid', 'true')
        input.focus()
        return fail('Enter your store’s website, like yourstore.com.')
      }
      input.removeAttribute('aria-invalid')
      if (turnstileKey && !turnstileToken) return fail('One moment: we are checking you are human.')
      if (runId) resetSession({ clearInput: false })
      submit.disabled = true
      submitLabel.textContent = 'Checking your store…'
      track('demo_url_entered', { url })
      try {
        const response = await fetch(`${appUrl}/api/demo/runs`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url, turnstileToken }),
        })
        const body = await response.json()
        if (!response.ok) {
          track('demo_refused', { url, code: body.error?.code })
          return fail(body.error?.message || 'Something went wrong. Try again in a moment.')
        }
        // Turnstile tokens are single-use. Prepare a new one for another store.
        turnstileToken = ''
        if (turnstileWidget !== null) window.turnstile?.reset(turnstileWidget)
        track('demo_run_started', { run_id: body.runId, replayed: body.replayed })
        follow(body.runId)
      } catch {
        fail('We could not reach Cartivate. Check your connection and try again.')
      }
    })

    // The offers: played from their cards, or from the cart's own Checkout
    // and close buttons, which the frame reports back. A card shows which
    // one is playing, and stays ticked once tried.
    const MESSAGE_OF = { bump: 'cartivate-demo:bump-offer', exit_intent: 'cartivate-demo:exit-offer' }
    const offerCards = [...root.querySelectorAll('[data-cvt-offer]')]
    const offerStatus = $('[data-cvt-offer-status]')
    const offerHint = offerStatus.textContent
    // Reuse the existing buttons and their offer state below the mobile cart.
    const offers = $('.cvt-offers')
    const offersHome = document.createComment('Offer controls desktop position')
    offers.before(offersHome)
    const mobileOffers = window.matchMedia('(max-width: 850px)')
    const placeOffers = () => {
      offers.classList.toggle('cvt-mobile-offers', mobileOffers.matches)
      if (mobileOffers.matches) {
        $('.cvt-device__screen').after(offers)
      } else {
        offersHome.after(offers)
      }
    }
    mobileOffers.addEventListener('change', placeOffers)
    placeOffers()
    let activeOffer = null
    let pendingOffer = null
    let offerRetry = null
    const requestOffer = offer => {
      clearInterval(offerRetry)
      pendingOffer = offer
      let attempts = 0
      const send = () => {
        frame.contentWindow?.postMessage({ type: MESSAGE_OF[offer] }, appUrl)
        if (++attempts >= 20) {
          clearInterval(offerRetry)
          pendingOffer = null
          offerStatus.textContent = 'The preview is still loading. Try Play again in a moment.'
        }
      }
      // The iframe's app may finish mounting after its document loads.
      // Stop retrying as soon as it acknowledges the requested offer.
      offerRetry = setInterval(send, 350)
      send()
    }
    // A completed run can arrive before its frame has loaded. Keep Play
    // unavailable until the message receiver has finished loading.
    frame.addEventListener('load', () => {
      if (!frame.hidden && frame.getAttribute('src')) {
        offerCards.forEach(card => { card.disabled = false })
        if (pendingOffer) requestOffer(pendingOffer)
      }
    })
    const markPlaying = offer => {
      activeOffer = offer
      offerCards.forEach(card => {
        const playing = card.dataset.cvtOffer === offer
        if (playing) card.dataset.tried = ''
        card.toggleAttribute('data-playing', playing)
        card.querySelector('[data-cvt-offer-label]').textContent = playing
          ? 'Playing'
          : card.hasAttribute('data-tried') ? 'Play again' : 'Play'
      })
    }
    offerCards.forEach(card =>
      card.addEventListener('click', () => {
        const offer = card.dataset.cvtOffer
        offerStatus.textContent = offerHint
        if (activeOffer) {
          // The demo runs one game at a time. Start a fresh preview when
          // switching/replaying, so the next Play never silently does nothing.
          clearInterval(offerRetry)
          pendingOffer = offer
          markPlaying(null)
          offerCards.forEach(button => { button.disabled = true })
          frame.src = frame.getAttribute('src')
        } else {
          requestOffer(offer)
        }
        // On a phone the cart is below: bring it into view to play.
        if (window.matchMedia('(max-width: 1023px)').matches) {
          $('[data-cvt-device]').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' })
        }
      })
    )

    root.querySelectorAll('[data-cvt-install]').forEach(link =>
      link.addEventListener('click', () =>
        track('demo_install_clicked', { run_id: runId, from: link.dataset.cvtInstall })
      )
    )

    root.querySelectorAll('[data-cvt-share]').forEach(button => {
      const label = button.querySelector('[data-cvt-share-label]') || button
      const idle = label.textContent
      let reset
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText($('[data-cvt-share-fallback]').value)
          label.textContent = 'Link copied'
          clearTimeout(reset)
          reset = setTimeout(() => { label.textContent = idle }, 2400)
        } catch {
          const fallback = $('[data-cvt-share-fallback]')
          fallback.hidden = false
          fallback.value = location.href
          fallback.focus()
          fallback.select()
          label.textContent = 'Select and copy link'
        }
        track('demo_link_copied', { run_id: runId, from: button.dataset.cvtShare })
      })
    })

    const resetSession = ({ clearInput = true } = {}) => {
      signal('reset')
      unsubscribe?.()
      unsubscribe = null
      runId = null
      resultShown = false
      clearInterval(offerRetry)
      pendingOffer = null
      activeOffer = null
      offerStatus.textContent = offerHint
      setResultState(false)
      offerCards.forEach(card => {
        card.disabled = true
        card.removeAttribute('data-tried')
        card.removeAttribute('data-playing')
        card.querySelector('[data-cvt-offer-label]').textContent = 'Play'
      })
      $('.cvt-design-notes').open = false
      clearInterval(clock)
      clock = null
      resetChanges()
      frame.hidden = true
      frame.removeAttribute('src')
      storeImg.removeAttribute('src')
      storeImg.classList.remove('is-loaded')
      $('[data-cvt-store-mobile]').removeAttribute('srcset')
      $('[data-cvt-store]').scrollTop = 0
      $('[data-cvt-placeholder]').hidden = false
      const url = new URL(location.href)
      url.searchParams.delete('run')
      if (inline) url.hash = 'store-preview-form'
      history.replaceState(null, '', url)
      submit.disabled = false
      submitLabel.textContent = idleSubmitLabel
      if (clearInput) input.value = ''
      errorBox.hidden = true
      $('[data-cvt-share-fallback]').value = ''
      show('form')
      if (clearInput) input.focus()
    }
    $('[data-cvt-again]').addEventListener('click', () => resetSession())

    window.addEventListener('message', event => {
      if (event.origin !== appUrl || event.source !== frame.contentWindow) return
      if (event.data?.type === 'cartivate-demo:interacted') track('demo_cart_interacted', { run_id: runId })
      if (event.data?.type === 'cartivate-demo:offer-shown') {
        if (event.data.offer === pendingOffer) {
          clearInterval(offerRetry)
          pendingOffer = null
        }
        markPlaying(event.data.offer)
        track('demo_offer_shown', { run_id: runId, offer: event.data.offer })
      }
      if (event.data?.type === 'cartivate-demo:offer-closed') markPlaying(null)
    })

    const start = () => {
      const params = new URL(location.href).searchParams
      const fromUrl = params.get('run')
      const preset = params.get('url')
      if (fromUrl) follow(fromUrl)
      else if (preset) {
        input.value = preset
        track('demo_url_preset', { url: preset })
        autoStart = true
        submitPreset()
      }
    }
    if (window.convex) start()
    else document.querySelector('script[src*="convex@"]')?.addEventListener('load', start)
  })()
